module.exports = __webpack_public_path__ + "img/vrart_5g.53415a62.svg";